import DropdownSelect from '../../../components/DropdownSelect';
import { GUMROAD_BUNDLE_ADMIN_PREVIEW_SCENARIOS } from './gumroadBundleAdminPreview';

const ADMIN_PREVIEW_SCENARIO_OPTIONS = GUMROAD_BUNDLE_ADMIN_PREVIEW_SCENARIOS.map(
  (scenario) => ({
    value: scenario.id,
    label: scenario.label,
    key: scenario.id,
  })
);

/**
 * Admin-only scenario picker — shown when preview mode is on (toggled via H key).
 * @param {{
 *   scenarioId: string,
 *   onScenarioChange: (id: string) => void,
 * }} props
 */
export function GumroadBundleAdminPreviewToolbar({ scenarioId, onScenarioChange }) {
  return (
    <div className="gumroad-bundle-admin-controls">
      <p className="gumroad-bundle-admin-hint">
        Mock UI only — switch scenarios to review copy and layout. Request and copy actions use
        sample data; nothing is saved.
      </p>
      <label className="gumroad-bundle-admin-scenario-label" htmlFor="gumroad-bundle-admin-scenario">
        <span>Scenario</span>
        <DropdownSelect
          id="gumroad-bundle-admin-scenario"
          value={scenarioId}
          options={ADMIN_PREVIEW_SCENARIO_OPTIONS}
          onValueChange={onScenarioChange}
          size="sm"
          placeholder="Select scenario…"
        />
      </label>
    </div>
  );
}
